module.exports = __webpack_public_path__ + "static/media/Language Culture.cae297d7.jpg";